import StartScreen from './start-screen';

export default StartScreen;
